import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { updateFixtureOrder } from '../../Redux/Slicers/Fixtures/UpdateFixtureOrderSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import { updateSlotOrder } from '../../Redux/Slicers/Slot/UpdateSlotOrderSlicer';

interface Item {
  level_id: string;
  fixtureCount: number;
  level_diagram: string;
  index: number;
}

interface TableProps {
  rows: Item[];
  columns: string[];
}

const LevelOrder: React.FC<any> = ({ rows, onSubmit }) => {
  const dispatch = useAppDispatch();
  const [items, setItems] = useState<Item[]>(rows);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const { data: updateSlotOrders } = useAppSelector(
    (state: any) => state?.UpdateSlotOrder
  );
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(true);
    console.log(updateSlotOrders);
  }, [updateSlotOrders]);
  //   console.log(updateFixtureOrders);

  // Handle drag start
  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  // Allow drop
  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (index: number) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const updatedItems = [...items];
    const [draggedItem] = updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(index, 0, draggedItem);

    const reorderedItems = updatedItems.map((item, idx) => ({
      ...item,
      order: idx + 1,
    }));

    setItems(reorderedItems);
    setDraggedIndex(null);
  };

  // Handle row click to select the item
  const handleRowClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleButtonClick = () => {
    // setOpen(true);
    dispatch(updateSlotOrder(items));
    console.log(items);
  };

  return (
    <>
      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Level ID
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Fixture{' '}
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Level Diagram
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={item.index}
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragOver={handleDragOver}
                onDrop={() => handleDrop(index)}
                onClick={() => handleRowClick(index)}
                style={{
                  cursor: 'move',
                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff', // Highlight selected row
                }}>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.level_id}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.fixtureCount}
                </td>
                <td
                  style={{
                    padding: '10px',
                    borderBottom: '1px solid #ccc',
                    height: '10px',
                  }}>
                  <img
                    src={
                      typeof item?.level_diagram === 'string'
                        ? `${process.env.REACT_APP_API_URL}/${item?.level_diagram}`
                        : ''
                    }
                    alt="level_diagram"
                    height={50}
                  />{' '}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button
          className="add_button"
          onClick={handleButtonClick}
          style={{ marginTop: '10px', width: '113px', marginLeft: '100px' }}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default LevelOrder;
